import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { IcroaFooterComponent } from './icroa-footer.component';

@NgModule({
  declarations: [
    IcroaFooterComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    IcroaFooterComponent
  ]
})
export class IcroaFooterModule { }
